module.exports = __webpack_public_path__ + "static/media/Prism element hierarchy.361aa9a2.png";